// extracted by mini-css-extract-plugin
export default {"root":"ProductLabels_root__1VwRo","label":"ProductLabels_label__fcan4","img_label":"ProductLabels_img_label__ZHewm","promotion":"ProductLabels_promotion__fDtTa"};